import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
import pasteListIcon from "../assets/pastelist.svg";
// import compareIcon from "../assets/compare.svg";
import topDealsIcon from "../assets/topdeals.svg";
import myListIcon from "../assets/myList.svg";

const actions = [
  {
    id: "lists",
    label: "My Grocery List",
    iconSrc: myListIcon,
    path: "/settings",
    search: "?tab=grocery",
  },
  // {
  //   id: "compare",
  //   label: "Compare Prices",
  //   iconSrc: compareIcon,
  //   path: "/features",
  // },
  {
    id: "deals",
    label: "Top Deals",
    iconSrc: topDealsIcon,
    path: "/top-deals",
  },
  {
    id: "paste",
    label: "Paste List",
    iconSrc: pasteListIcon,
    path: "/paste-list",
  },
];

export default function HomeQuickActionsBar({ onOpenAuth }) {
  const navigate = useNavigate();
  const token = useAppSelector((s) => s.auth.token);
  const normalizedToken = typeof token === "string" ? token.trim() : token;
  const isLoggedIn =
    Boolean(normalizedToken) &&
    normalizedToken !== "null" &&
    normalizedToken !== "undefined";

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 gap-2 min-[400px]:grid-cols-2 sm:grid-cols-4 md:gap-6 lg:gap-8">
        {actions.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => {
              if (item.id === "compare" && !isLoggedIn) {
                onOpenAuth?.("login");
                return;
              }
              navigate(`${item.path}${item.search || ""}`);
            }}
            className="flex min-h-[56px] w-full flex-row items-center justify-start gap-3 rounded-xl border border-[#E6EAF0] bg-white px-3 py-2.5 text-left shadow-sm sm:min-h-[60px] sm:px-4"
          >
            <img
              src={item.iconSrc}
              alt=""
              width={48}
              height={48}
              className="h-11 w-11 shrink-0 object-contain sm:h-12 sm:w-12"
              aria-hidden
            />
            <span className="whitespace-nowrap text-[16px] font-bold leading-none text-[#24303A] min-[400px]:text-[14px] sm:text-[18px]">
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
